module.exports = __webpack_public_path__ + "img/万水千山.7f8dc6da.png";